class HomeRun extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.boxContents = this.querySelectorAll('[data-product-id]');
        this.totalPrice = 0;
        this.totalRetailPrice = 0;
        this.parseUTMParams()
        this.attachQuantityButtons()
        this.calculateTotal()
        this.clearCart()
        this.querySelector('[atc-button]').addEventListener("click", () => {
            this.addToCart()
        })
    }

    parseUTMParams() {
        const params = new URLSearchParams(location.search)
        this.discountCode = params.get("discount_code");
        this.checkoutId = params.get("checkout_session_id");
    }

    calculateTotal() {
        this.boxContents.forEach((item) => {
            this.totalPrice += parseInt(item.getAttribute('data-discount-price')) * parseInt(item.getAttribute('data-quantity'))
            this.totalRetailPrice += parseInt(item.getAttribute('data-retail-price')) * parseInt(item.getAttribute('data-quantity'))
        })
        this.totalPrice = (this.totalPrice / 100)
        this.totalRetailPrice = (this.totalRetailPrice / 100)
        this.querySelector('[atc-price]').textContent = `$${this.totalPrice.toFixed(2)}`;
        this.querySelector('[price-difference]').textContent = `$${(this.totalRetailPrice - this.totalPrice).toFixed(2)}`;
    }
    attachQuantityButtons() {
        this.boxContents.forEach((node) => {
            const minus = node.querySelector('[item-minus]')
            const plus = node.querySelector('[item-plus]')

            const quantityLabel = node.querySelector('[data-quantity-label]')

            minus.addEventListener('click', () => {
                const currentValue = parseInt(node.getAttribute('data-quantity'))
                if (currentValue < 1) return
                node.setAttribute('data-quantity', currentValue - 1)
                quantityLabel.textContent = currentValue - 1
                this.calculateTotal()
            })

            plus.addEventListener('click', () => {
                const currentValue = parseInt(node.getAttribute('data-quantity'))
                node.setAttribute('data-quantity', currentValue + 1)
                quantityLabel.textContent = currentValue + 1
                this.calculateTotal()
            })
        })
    }

    householdForm() {
        const bathroomNode = this.querySelector('[data-bathroom-quantity]')
        const bedroomNode = this.querySelector('[data-bedroom-quantity]')

        const bathroomQuantityLabel = bathroomNode.querySelector('[quantity-label]')
        const bedroomQuantityLabel = bedroomNode.querySelector('[quantity-label]')

        bathroomNode.querySelector('[minus-button]').addEventListener('click', () => {
            const currentValue = parseInt(bathroomNode.getAttribute('data-bathroom-quantity'))
            if (currentValue <= 1) return
            bathroomNode.setAttribute("data-bathroom-quantity", currentValue - 1)
            bathroomQuantityLabel.textContent = currentValue - 1
        })

        bathroomNode.querySelector('[plus-button]').addEventListener('click', () => {
            const currentValue = parseInt(bathroomNode.getAttribute('data-bathroom-quantity'))
            bathroomNode.setAttribute("data-bathroom-quantity", currentValue + 1)
            bathroomQuantityLabel.textContent = currentValue + 1
        })

        bedroomNode.querySelector('[plus-button]').addEventListener('click', () => {
            const currentValue = parseInt(bedroomNode.getAttribute('data-bedroom-quantity'))
            bedroomNode.setAttribute("data-bedroom-quantity", currentValue + 1)
            bedroomQuantityLabel.textContent = currentValue + 1
        })

        bedroomNode.querySelector('[minus-button]').addEventListener('click', () => {
            const currentValue = parseInt(bedroomNode.getAttribute('data-bedroom-quantity'))
            if (currentValue <= 1) return
            bedroomNode.setAttribute("data-bedroom-quantity", currentValue - 1)
            bedroomQuantityLabel.textContent = currentValue - 1
        })
    }

    async addToCart() {
        const bundleProductData = {
            productId: this.getAttribute("data-bundle-product-id"),
            variantId: this.getAttribute("data-default-variant-id"),
            sellingPlan: this.getAttribute("data-selling-id"),
            handle: this.getAttribute("data-bundle-product-handle"),
        };

        const bundle = {
            externalVariantId: bundleProductData.variantId,
            externalProductId: bundleProductData.productId,
            selections:
                Array.from(this.boxContents).map((item) => {
                    return {
                        collectionId: this.getAttribute("data-bundle-collection-id"),
                        externalProductId: item.getAttribute('data-product-id'),
                        externalVariantId: item.getAttribute("data-variant-id"),
                        quantity: parseInt(item.getAttribute('data-quantity')),
                        sellingPlan: parseInt(item.getAttribute("data-selling-plan")),
                    }
                })
        };

        const cartItems = await recharge.bundle.getDynamicBundleItems(bundle, bundleProductData.handle);
        const cartData = {
            items: cartItems.map((item) => {
                const updatedLineItem = {
                    ...item,
                };

                if (this.checkoutId) {
                    updatedLineItem.properties = {
                        ...updatedLineItem.properties,
                        __checkout_session_id: this.checkoutId
                    }
                }

                if (this.discountCode) {
                    updatedLineItem.properties = {
                        ...updatedLineItem.properties,
                        __discountCode: this.discountCode
                    }
                }

                return updatedLineItem;
            }), discount: this.discountCode
        };

        await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cartData),
        }).then(() => {
            location.href = "/checkout"
        })
    }

    clearCart() {
        fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
}

if (!customElements.get("homerun-component")) {
    customElements.define("homerun-component", HomeRun)
}